export const PAYMENT = 'PAYMENT';
export const SUCCESS = 'SUCCESS';
export const NOT_FOUND = 'NOT_FOUND';
export const COMPLETE_CART = 'COMPLETE_CART';

export const TRADEMARKS = 'TRADEMARKS';
export const TRADEMARKS_DETAILS = 'TRADEMARKS_DETAILS';
export const LOGIN = 'LOGIN';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_RESET = 'RESET_PASSWORD_RESET';
export const APPLICATION_PROCESS = 'APPLICATION_PROCESS';

export default {
    PAYMENT,
    NOT_FOUND,
    SUCCESS,
    TRADEMARKS,
    TRADEMARKS_DETAILS,
    LOGIN,
    RESET_PASSWORD,
    RESET_PASSWORD_RESET,
    COMPLETE_CART,
    APPLICATION_PROCESS
};
